import React, { Component } from 'react';
import { Grid, Image, Button } from 'react-bootstrap';
import '../../content/css/ContractReviewer.css';
import { history } from '../../helpers';
import AuthService from "../../services/auth.service";

var logo = require("../../content/images/legly_logo_color.svg");

export default class Login extends Component {
    constructor(props) {
        super(props);

        this.authService = new AuthService();
    }

    handleFreemiumLoginClick = () => {
        if (!this.authService.isAuthenticated() && !this.authService.isGuest()) {
            this.authService.continueAsGuest();
        }

        history.push("/");
    }

    handlePremiumLoginClick = () => {
        if (!this.authService.isAuthenticated()) {
            this.authService.login();
        }
        else {
            history.push("/");
        }
    }

    handleBecomeCustomerClick = () => {
        if (!this.authService.isAuthenticated()) {
            window.location.href = 'https://www.legly.io/pricing';
        }
        else {
            history.push("/");
        }
    }

    render() {
        return (
            <Grid className="prototype" fluid>
                <div className="content-container">
                    <div className="prototype-start">
                        <Image className="logo" src={logo} />
                        <h2>{this.props.text}</h2>
                        {this.props.showOptions &&
                            <div className="login-view">
                                <Button bsSize="xlarge" onClick={this.handleFreemiumLoginClick}>Continue to Freemium</Button>
                                <h4>If you already are, or want to become, a customer:</h4>
                                <div>
                                    <Button bsSize="small" onClick={this.handlePremiumLoginClick}>Login</Button>
                                    <Button bsSize="small" onClick={this.handleBecomeCustomerClick}>Subscribe</Button>
                                </div>
                                <p>By using this service you agree to our <a href="https://www.legly.io/terms-of-service">Terms of Service</a>.</p>
                            </div>
                        }
                    </div>
                </div>
            </Grid>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Home/Login.js